import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import type { ListQuery, CategoryPaymentMethodListVo, UserCardVo } from './type';

/**
 * c端支付方式获取
  GET /payment/api/payment/method/list
  接口ID：251277014
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-251277014
 */
export const getPaymentList = (params: ListQuery): AxiosPromise<CategoryPaymentMethodListVo[]> => {
  return request({
    url: '/payment/api/payment/method/list',
    method: 'get',
    params
  });
};

/**
 * 获取用户卡片信息
  GET /payment/user/card/list
  接口ID：233835339
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-233835339
 */
export const getUserCardInfo = (): AxiosPromise<UserCardVo> => {
  return request({
    url: '/payment/user/card/list',
    method: 'get'
  });
};
